import type { CardDirection, FlowThemeCardMotion } from '../../cardMotion';

/** The card grows up into place like a new leaf opening, and the last one settles down out of view. */
export const greenhouseCardMotion = (isMobile: boolean): FlowThemeCardMotion => {
  const rise = isMobile ? 26 : 36;
  return {
    variants: {
      enter: (direction: CardDirection) => ({ opacity: 0, y: direction > 0 ? rise : -rise, scale: 0.94, rotate: direction > 0 ? -1.2 : 1.2 }),
      center: { opacity: 1, y: 0, scale: 1, rotate: 0 },
      exit: (direction: CardDirection) => ({ opacity: 0, y: direction > 0 ? -rise * 0.7 : rise * 0.7, scale: 1.03, rotate: direction > 0 ? 1 : -1 }),
    },
    transition: { duration: 0.95, ease: [0.2, 0.9, 0.3, 1.04] },
    style: { transformOrigin: '50% 100%' },
  };
};
